import { Component, OnInit, ChangeDetectionStrategy, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { SAMLLogin } from '../shared/models/auth/saml.login.model';
import { Company } from '../shared/models/company.model';
import { AuthService } from '../shared/services/auth.service';
import { GlobalService } from '../shared/services/global.service';
import { ApiResponse } from '../shared/models/api.response';
import { SnackbarService } from '../shared/services/snackBarService.service';
import { CompanyApiService } from '../company/services/company-api.service';
@Component({
    selector: 'app-saml',
    templateUrl: './saml.component.html',
    styleUrls: ['./saml.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SamlComponent implements OnInit {
  samlLogin: SAMLLogin;
  company: Company;
  private readonly platformId = inject(PLATFORM_ID);
  constructor(private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private snackbarservice: SnackbarService,
    private companyService: CompanyApiService,
    private globalService: GlobalService) {
    this.samlLogin = new SAMLLogin();
    this.company = new Company();
  }

  ngOnInit(): void {
    // Log in only in the browser. Rendered on the server, this exchanged the
    // one-time accessToken there (so the browser's own attempt then failed) and
    // stored the session in a cookie the server can't keep.
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.activatedRoute.queryParams.subscribe(params => {
        var accessData = params['accessID'];
        if (!accessData || !params['accessToken']) {
          this.router.navigateByUrl('/company');
          return;
        }
        var splitArray = accessData.split('-||-');
        this.samlLogin.token = params['accessToken'];
        let companyName = splitArray[0];
        this.samlLogin.userUuid = splitArray[2];
        this.company.companyName = companyName;
        this.companyService.companyDetail(this.company.companyName).subscribe((res: ApiResponse<Company>) => {
          
          this.company = res.data;
          this.globalService.setCompany('company', JSON.stringify(res.data));
          this.samlLogin.companyId = this.company.id;
          this.samlLogin.accessId = this.company.accessId;
          this.authService.samlLogin(this.samlLogin).subscribe((login: ApiResponse<SAMLLogin>) => {
            if (login) {
              this.globalService.setUser('userData', JSON.stringify(login.data));
              this.snackbarservice.open(login.message,'X' ,'success')
              if (login.data.userType == 'Requestor')
                this.router.navigateByUrl('/access-request/submitted-requests');
              else
                this.router.navigateByUrl('/');
            }
          }, () => {
            // this.router.navigateByUrl('/company?');
            this.router.navigateByUrl(`/company?error=${params['error']}`);
          });
        });
      });
  }
}
